// Each file here is tied to the routes defined in the routes folder.
// All API calls originating from that page can be put here

/* eslint-disable no-undef */
import { generatePath } from 'react-router-dom';
import { axiosInstance } from '../common';

// Define all api endpoint urls at the top
const ENDPOINT = '/customer/:id';
const ENDPOINT_AUDIT_TRAIL = '/customer/:id/audit-trial';
const ENDPOINT_AUDIT_TRAIL_DETAILS = '/customer/:id/audit-trial/:logId';


// Define all api functions here
export const getCustomerDetails = async (id) => {
    return await axiosInstance.get(generatePath(ENDPOINT, {
        id
    })).then(({ data }) => data)
}

export const updateCustomerDetails = (id, payload) => {
    return axiosInstance.patch(generatePath(ENDPOINT, {
        id
    }), payload)
}

export const getCustomerAuditTrail = async (id) => {
    return await axiosInstance.get(generatePath(ENDPOINT_AUDIT_TRAIL, {
        id
    })).then(({ data }) => data)
}

export const getCustomerAuditTrailDetails = async (id, logId) => {
    return await axiosInstance.get(generatePath(ENDPOINT_AUDIT_TRAIL_DETAILS, {
        id,
        logId
    })).then(({ data }) => data)
}

/* Company artwork library */
const ENDPOINT_ARTWORKS = '/customer/:id/artworks';
const ENDPOINT_ARTWORK_SINGLE = '/customer/:id/artworks/:artworkId';

export const getCustomerArtworks = async (id) => {
    return await axiosInstance.get(generatePath(ENDPOINT_ARTWORKS, {
        id
    })).then(({ data }) => data)
}

export const archiveCustomerArtwork = (id, artworkId) => {
    return axiosInstance.delete(generatePath(ENDPOINT_ARTWORK_SINGLE, {
        id,
        artworkId
    })).then(({ message }) => message)
}
